define('TescoMobile_Eecc/js/proceed-to-checkout-modal',['jquery', 'TescoMobile_CareHub/js/action/end-session'], function ($, endSession) {
  return function (config) {
    $(document).on('change', config.saveContractRadioBtn, function () {
      $('#save-yes').is(':checked') ? $('.fca-save-basket-collapsed').show() : $('.fca-save-basket-collapsed').hide();
    });
    $(document).on('change', config.continueRadioBtn, function () {
      if ($('#continue-no').is(':checked')) {
        $('.continue-rejected-block').removeClass('no-display');
        $(this).closest('li').addClass('request-contract-item');
        $(this).closest('.modal-inner-wrap').addClass('rejected');
      } else {
        $('.continue-rejected-block').addClass('no-display');
        $(this).closest('li').removeClass('request-contract-item');
        $(this).closest('.modal-inner-wrap').removeClass('rejected');
      }
    });
    $(document).on('click', '.trigger-collapse', function () {
      $('.show-accessible-format-form').trigger('click');
    });
    $(document).on('click', '.continue-rejected-block button', function () {
      endSession();
    });
    $(document).on('contentUpdated', function (event) {
      if ($(event.target).closest('.carehub-cms-block-modal').length) {
        $('.accessible-format-form-content .form-wrapper').applyBindings();
      }
    });
  };
});

